export default __webpack_public_path__ + "1c7c99147015bcb8eec2fe2bee35c6d6.svg";